module.exports = __webpack_public_path__ + "static/media/homeitem7.7119e6d1.png";